module.exports = __webpack_public_path__ + "img/account_profile_user.7894caa6.svg";